export default "__VITE_ASSET__De3CLSJC__"